import { render, staticRenderFns } from "./TestimonialCard.vue?vue&type=template&id=f1089190"
import script from "./TestimonialCard.vue?vue&type=script&lang=js"
export * from "./TestimonialCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports